module.exports = __webpack_public_path__ + "static/media/plan-acumula-400gb.b9fdb018.svg";